export const GET_LIST = '@@updates/GET_LIST';
export const GET_LIST_SUCCESS = '@@updates/GET_LIST_SUCCESS';
export const GET_LIST_ERROR = '@@updates/GET_LIST_ERROR';

export const DELETE_UPDATES = '@@updates/DELETE_UPDATES';
export const DELETE_UPDATES_SUCCESS = '@@updates/DELETE_UPDATES_SUCCESS';
export const DELETE_UPDATES_ERROR = '@@updates/DELETE_UPDATES_ERROR';
